<template>
  <div class="max-w-[720px] w-full px-4 sm:px-0 sm:mr-5">
    <h2 class="w-full text-center mb-8">
      {{ $t('messages.menu.account_info') }}
    </h2>
    <div class="list--account flex flex-col border border-gray-200 bg-white rounded-lg sm:ml-10 mb-10 sm:mb-0 bg-white]">
      <ProfileEdit :user="user" />
      <PasswordChange :user="user" />
    </div>
  </div>
</template>
<script>
import { useAuthStore } from '@/stores/auth';
import ProfileEdit from './ProfileEdit.vue';
import PasswordChange from './PasswordChange.vue';


export default {
  name: 'AccountInfo',
  components: {
    ProfileEdit,
    PasswordChange
  },
  computed: {
    user() {
      const authStore = useAuthStore();
      return authStore.current_user || {
        first_name: 'N/A',
        last_name: 'N/A',
        email: 'no-email@example.com',
        country: 'TW',
        contactPerson: 'None'
      };
    },
  },
}
</script>
